import PropTypes from "prop-types";
import React, { Suspense } from "react";

// APP & COMPONENTS
import { IS_STAFF_ROLE, IS_SUPERADMIN_ROLE } from "common/ComponentAccess";
import { authProtectedRoutes, openRoutes, publicRoutes } from "./routes";
import { Switch, BrowserRouter as Router } from "react-router-dom";
import HorizontalLayout from "./components/HorizontalLayout/";
import VerticalLayout from "./components/VerticalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";
import DataWrapper from "components/DataWrapper";
import { connect, useDispatch } from "react-redux";
import PreLoader from "component/Loader/PreLoader";
import { layoutTypes } from "constants/layout";
import { changeLayout } from "store/actions";
import Authmiddleware from "./routes/route";
import { me } from "constants/Client";

// SCSS
import "./assets/scss/theme.scss";
import "react-perfect-scrollbar/dist/css/styles.css";

const App = props => {
  const dispatch = useDispatch();

  function getLayout() {
    let layoutCls = VerticalLayout;
    switch (props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  }

  function checkLayout() {
    const layoutCls = HorizontalLayout;
    if (props.layout.layoutType !== layoutTypes.HORIZONTAL && (IS_STAFF_ROLE() || IS_SUPERADMIN_ROLE() || me()?.role === "participant")) {
      dispatch(changeLayout(layoutTypes.HORIZONTAL));
      return layoutCls;
    }
    return getLayout();
  }

  const Layout = checkLayout();
  return (
    <DataWrapper>
      <Router>
        <Suspense
          fallback={
            <div className='vh-center' style={{ height: "100vh", width: "100%" }}>
              <PreLoader />
            </div>
          }>
          <Switch>
            {publicRoutes.map((route, idx) => (
              <Authmiddleware path={route.path} layout={NonAuthLayout} component={route.component} key={idx} isAuthProtected={false} exact />
            ))}
            {openRoutes.map((route, idx) => (
              <Authmiddleware path={route.path} layout={NonAuthLayout} component={route.component} key={idx} isAuthProtected={false} isOpenRoute={true} exact />
            ))}
            {authProtectedRoutes.map((route, idx) => (
              <Authmiddleware path={route.path} layout={Layout} component={route.component} key={idx} isAuthProtected={true} exact />
            ))}
          </Switch>
        </Suspense>
      </Router>
    </DataWrapper>
  );
};

App.propTypes = {
  layout: PropTypes.any,
};

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStateToProps, null)(App);
